module.exports = __webpack_public_path__ + "static/media/staff_outline.89d78b55.svg";